/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Web_OnlyInputs */

const vi_shop_home_web_only = /** @type {(inputs: Shop_Home_Web_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chỉ web`)
};

/**

* @param {Shop_Home_Web_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_web_only = /** @type {((inputs?: Shop_Home_Web_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Web_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_web_only(inputs)
});